import {createFileRoute} from '@tanstack/react-router';

import ImagePageWithShowSamplesLink from '~components/common/ImagePageWithShowSamplesLink';
import {ModelProvider} from 'src/contexts/ModelProvider';

export const Route = createFileRoute('/model/add-samples/image')({
  component: ModelAddSamplesImagePage,
});

function ModelAddSamplesImagePage(): JSX.Element {
  return (
    <ModelProvider mode='model-pages'>
      <ImagePageWithShowSamplesLink />
    </ModelProvider>
  );
}
